module.exports = __webpack_public_path__ + "img/image-moon.8461d2c5.webp";